import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface Props {
  hint?: 'missing-scene-id' | 'scene-offline' | 'preview-token-invalid';
}

export function NotFoundPage({ hint }: Props) {
  const { t } = useTranslation();
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-4 bg-gray-950 text-white">
      <h1 className="text-4xl font-bold">404</h1>
      <p className="text-sm text-white/60">{hint ? t(`errors.${hint}`) : t('errors.notFound')}</p>
      <Link to="/" className="text-brand text-sm underline">
        {t('errors.back')}
      </Link>
    </div>
  );
}
